import React from 'react'
import { Form } from 'react-bootstrap'
import './claimform.scss'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
const ClaimstatusForm = () => {

    return (
        <div className='claimstatusform'>
            <div className='common-heading'>
                <h2>Claim status</h2>
            </div>
            <div className='text'>
                <p>To locate and review a claim, enter the claim number and date of loss below.</p>
            </div>
            <Form>
                <div className='text-fleld'>
                    {/* <TextField id="outlined-basic" label="Outlined" variant="outlined"/> */}
                    <FormControl sx={{ width: '100%' }} variant="outlined">
                        <InputLabel >Claim number</InputLabel>
                        <OutlinedInput
                            type='text'
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton aria-label='label' edge="end" >
                                        <HelpOutlineIcon />
                                    </IconButton>
                                </InputAdornment>}
                            label="Claim number"
                        />
                    </FormControl>
                </div>
                <div className='text-fleld'>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DemoContainer components={['DatePicker']} >
                            <DatePicker label="Date of loss"
                                sx={{ width: '100%' }}
                                slots={{
                                    openPickerIcon: CalendarMonthIcon,
                                }} />
                        </DemoContainer>
                    </LocalizationProvider>
                </div>
                <div className='submit-button'>
                    <button type='button'>Submit</button>
                </div>
            </Form>
        </div>
    )
}

export default ClaimstatusForm
